import { render } from "./EconomicsReviewCard.vue?vue&type=template&id=8ef94686&scoped=true"
import script from "./EconomicsReviewCard.vue?vue&type=script&lang=js"
export * from "./EconomicsReviewCard.vue?vue&type=script&lang=js"

import "./EconomicsReviewCard.vue?vue&type=style&index=0&id=8ef94686&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ef94686"]])

export default __exports__